import en from './en.json'
import it from './it.json'

export const dsuQuotaTranslations = {
	en,
	it
} as const
